const toString = (val) => {
    switch (typeof val) {
        case 'string':
            return val;
        case 'number':
            return `${val}`;
        case 'boolean':
            return val ? '1' : '0';
        case 'object':
            return JSON.stringify(val);
        case 'bigint':
            return val.toString();
        default:
            return undefined;
    }
};
export const stringifyFields = (params) => {
    return Object.keys(params).reduce((result, key) => {
        const stringVal = toString(params[key]);
        if (stringVal !== undefined) {
            // eslint-disable-next-line no-param-reassign
            result[key] = stringVal;
        }
        return result;
    }, {});
};
